import { Modal } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React, { CSSProperties } from 'react';

type Props<T> = {
	onOk?: (value: T) => void;
	onCancel?: (value: T) => void;
	content: React.ReactNode;
	title?: string | React.ReactNode;
	okText?: string;
	cancelText?: string;
	width?: string;
	style?: CSSProperties;
	hideCancelButton?: boolean;
};

const okButtonProps: ButtonProps = { id: 'warningOkButton' };
const cancelButtonProps: ButtonProps = { id: 'warningCancelButton' };

const ModalWarning = <T extends object | string | number>({ content, onCancel, onOk, title, cancelText, okText, width, style, hideCancelButton }: Props<T>) => {
	return Modal.warning({
		keyboard: false,
		maskClosable: false,
		style,
		width,
		content,
		title,
		onOk: onOk,
		onCancel,
		okText: okText || 'Yes',
		cancelText: hideCancelButton ? undefined : cancelText || 'No',
		okButtonProps: okButtonProps,
		cancelButtonProps: cancelButtonProps,
	});
};

export { ModalWarning };
